/* eslint-disable no-loop-func */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Moment from 'moment';
import { FilteredColumn, IServiceError, Language } from '@eta/components';
import saveAs from 'file-saver';
import * as XLSX from 'xlsx-color';
import { Dates, POSStatus } from '../common/config/constants';
import {
    ModelStatus,
    VendorStatus,
} from '../Services/POS/PosService';
import { isEmptyText } from './utils';


export class UIHelpers {
    public static ExportFile(
        excelUrl: string,
        contentType: string,
        fileName: string
    ) {
        const oReq = new XMLHttpRequest();
        oReq.open('get', excelUrl, true);
        oReq.responseType = 'blob';
        oReq.onload = () => {
            const blobContent = oReq.response;
            const blob = new Blob([blobContent], { type: contentType });
            saveAs(blob, fileName);
        };
        oReq.send(null);
    }

    public static downloadExcel(
        data: any[],
        fileName: string,
        CellConfig: any[],
        rtl: string,
        cols: any[]
    ) {
        const titleName = fileName.length <= 31 ? fileName : '';
        const sheetName = fileName.length > 31 ? fileName : '';
        const EXCEL_TYPE =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        let newWB = XLSX.utils.book_new();
        const lang = rtl.includes('en');
        const newWS = XLSX.utils.json_to_sheet(data, {
            cellStyles: true,
            cellDates: true,
        });
        newWB = {
            ...newWB,
            Workbook: {
                Views: [{ RTL: !lang }],
            },
        };

        for (let i = 0; i < cols.length; i += 1) {
            newWS[
                XLSX.utils.encode_cell({
                    c: i,
                    r: 0,
                })
            ] = CellConfig[i];
        }

        newWS['!cols'] = cols;
        if (newWS['!ref']) {
            const range = XLSX.utils.decode_range(newWS['!ref']);
            for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum += 1) {
                for (let colNum = range.s.c; colNum <= range.e.c; colNum += 1) {
                    let Cell =
                        newWS[XLSX.utils.encode_cell({ r: rowNum, c: colNum })];
                    Cell = {
                        ...Cell,
                        s: {
                            alignment: { vertical: 'center', wrapText: true },
                        },
                    };
                    newWS[XLSX.utils.encode_cell({ r: rowNum, c: colNum })] = Cell;
                }
            }
        }
        XLSX.utils.book_append_sheet(newWB, newWS, titleName);
        const excelBuffer = XLSX.write(newWB, {
            bookType: 'xlsx',
            type: 'array',
            cellStyles: true,
            cellDates: true,
            sheet: sheetName,
        });
        const blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        saveAs(blob, fileName + EXCEL_EXTENSION);
    };


    public static getDateFormatted = (
        dateString: string | undefined,
        dateFormat: string
    ): Date | undefined => {
        if (dateString === '' || dateString === undefined) return undefined;
        const dateMomentObject = Moment(dateString, dateFormat);
        const dateObject = dateMomentObject.toDate();
        return dateObject;
    };

    public static getDateFormattedstr = (
        dateString: string,
        dateFormat: string
    ): string => {
        if (!dateString) return dateString;
        const dateMomentObject = Moment(dateString).format(dateFormat);
        return dateMomentObject;
    };

    public static addDays(date: Date, days: number): Date | undefined {
        if (!Moment(date, 'DD/MM/YYYY', true).isValid()) return undefined;

        date.setDate(date.getDate() + days);
        return date;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static GetErrors(exp: any): any {
        // eslint-disable-next-line no-param-reassign
        exp.response = exp?.response || { error: {} };
        // eslint-disable-next-line no-param-reassign
        exp.response.error =
            exp?.response?.error || exp?.response?.data?.error || {};
        // eslint-disable-next-line no-param-reassign
        exp.response.error.details =
            exp.response.error.details ||
            exp.response?.data?.error?.details ||
            {};
        // eslint-disable-next-line no-param-reassign
        exp.response.error.message =
            exp.response.error.message ||
            exp.response?.data?.error?.message ||
            {};
        const {
            response: {
                error: { details },
            },
            message,
            status,
        } = exp;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errors: any = {};
        switch (status) {
            // bad request : validation error
            case 400:
                // eslint-disable-next-line no-restricted-syntax
                if (details && Object.keys(details).length) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const error of details) {
                        if (error.target) errors[error.target] = error.message;
                        else
                            errors.BusinessErrors =
                                (errors.BusinessErrors ?? '') + error.message;
                    }
                } else {
                    errors.BusinessErrors = exp.response.error.message;
                }
                break;
            default:
                errors.ExceptionMessage = message ?? exp.response.error.message;
                break;
        }
        return errors;
    }

    public static GetErrorsMessages(exp: any): any {
        // eslint-disable-next-line no-param-reassign
        exp.response = exp?.response || { error: {} };
        // eslint-disable-next-line no-param-reassign
        exp.response.error =
            exp?.response?.error || exp?.response?.data?.error || {};
        // eslint-disable-next-line no-param-reassign
        exp.response.error.details =
            exp.response.error.details ||
            exp.response?.data?.error?.details ||
            {};
        // eslint-disable-next-line no-param-reassign
        exp.response.error.message =
            exp.response.error.message ||
            exp.response?.data?.error?.message ||
            {};
        const {
            response: {
                error: { details, code },
            },
            message,
        } = exp;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errors: any = {};
        switch (code) {
            // bad request : validation error
            case 'ValidationError':
                // eslint-disable-next-line no-restricted-syntax
                if (details && Object.keys(details).length) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const error of details) {
                        if (error.target) errors[error.target] = error.message;
                        else
                            errors.BusinessErrors =
                                (errors.BusinessErrors ?? '') + error.message;
                    }
                } else {
                    errors.BusinessErrors = exp.response.error.message;
                }
                break;
            default:
                errors.ExceptionMessage = message ?? exp.response.error.message;
                break;
        }
        return errors;
    }

    public static GetError(exp: any): any {
        // eslint-disable-next-line no-param-reassign
        exp.response = exp?.response || { error: {} };
        // eslint-disable-next-line no-param-reassign
        exp.response.error =
            exp?.response?.error || exp?.response?.data?.error || {};
        // eslint-disable-next-line no-param-reassign
        exp.response.error.details =
            exp.response.error.details ||
            exp.response?.data?.error?.details ||
            {};
        // eslint-disable-next-line no-param-reassign
        exp.response.error.message =
            exp.response.error.message ||
            exp.response?.data?.error?.message ||
            {};
        const {
            response: {
                error: { details },
            },
            status,
        } = exp;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errors: any = {};
        switch (status) {
            // bad request : validation error
            case 400:
                // eslint-disable-next-line no-restricted-syntax
                if (details && Object.keys(details).length) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const error of details) {
                        if (error.target) errors[error.target] = error.message;
                        else
                            errors.BusinessErrors =
                                (errors.BusinessErrors ?? '') + error.message;
                    }
                } else {
                    errors.BusinessErrors = exp.response.error.message;
                }
                break;
            default:
                errors.ExceptionMessage = exp.response.error.message;
                break;
        }
        return errors;
    }

    public static GetCurrentErrors(
        message: string,
        status: number,
        details: IServiceError[] | undefined
    ) {
        const errors: any = {};
        switch (status) {
            // bad request : validation error
            case 400:
                // eslint-disable-next-line no-restricted-syntax
                if (details && Object.keys(details).length) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const error of details) {
                        if (error.target)
                            errors[error.target?.split(' ')?.join('')] =
                                error.message;
                        else
                            errors.BusinessErrors =
                                (errors.BusinessErrors ?? '') + error.message;
                    }
                }
                break;
            default:
                errors.ExceptionMessage = message;
                break;
        }
        return errors;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static getArrayError = (
        error: any | undefined,
        arrayName: any,
        index: number,
        target: string
    ) => {
        return error?.hasOwnProperty(`${arrayName}[${index}].${target}`)
            ? error[`${arrayName}[${index}].${target}`]
            : '';
    };

    public static checkBranchActivity = (
        branchStartDate?: Date,
        branchCeaseDate?: Date | undefined): boolean => {
        const todayDateUTC = new Date();
        let branchActive = false;
        if (branchStartDate)
            branchActive = branchStartDate <= todayDateUTC;
        const branchNotCeased: boolean =
            !branchCeaseDate || todayDateUTC < branchCeaseDate;
        return branchActive && branchNotCeased;
    };

    public static getNotSubmitReason = (
        item: any,
        activeDevice: boolean
    ) => {
        const inActiveVendor = item.vendorStatus === VendorStatus.InActive;
        const inActiveModel = item.modelStatus === ModelStatus.InActive;
        let canSubmit = true;

        let reason;
        if (item.status === 'Retiring' || item.statusId === POSStatus.Retiring) {
            return {
                canSubmit: false,
                noSubmitReason: 'posRetiring',
            };

        }
        if (item.status === 'Retired' || item.statusId === POSStatus.Retired) {
            return {
                canSubmit: false,
                noSubmitReason: 'posRetired',
            };
        }
        if (activeDevice) {
            if (inActiveModel) {
                reason = 'modelInActive';
            } else if (inActiveVendor) {
                reason = 'vendorInActive';
            } else if (item.modelOutOfRange) {
                reason = 'modelOutOfRange';
            } else if (item.vendorOutOfRange) {
                reason = 'vendorOutOfRange';
            }
        } else {
            reason = 'deviceInActive';
            canSubmit = false;
        }

        if (reason) canSubmit = false;

        return {
            canSubmit,
            noSubmitReason: reason,
        };
    };

    public static GetCustomErrors(exp: any): any {
        // eslint-disable-next-line no-param-reassign
        exp.response = exp.response || { error: {} };
        // eslint-disable-next-line no-param-reassign
        exp.response.details = exp.response.details || {};

        const {
            response: { details, message },
            status,
        } = exp;

        const errors: any = {};
        switch (status) {
            // bad request : validation error
            case 400:
            case 404:
                // eslint-disable-next-line no-restricted-syntax
                if (details && Object.keys(details).length) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const error of details) {
                        if (error.target)
                            errors[error.target?.split(' ')?.join('')] =
                                error.message;
                        else
                            errors.BusinessErrors =
                                (errors.BusinessErrors ?? '') + error.message;
                    }
                }
                break;
            default:
                errors.ExceptionMessage = message;
                break;
        }
        if (details && details.length > 0) return details[0];
        if (message) return { message };
        return 'Error occured while processing';
    }

    public static filterObject = (data: any) => {
        const newData = [];
        for (let index = 0; index < data.length; index += 1) {
            newData.push(
                Object.keys(data[index])
                    .filter(
                        (key) =>
                            key !== 'serialNumber' &&
                            key !== 'vendorName' &&
                            key !== 'formatedAddress' &&
                            key !== 'taxpayerName'
                    )
                    .reduce((device, key: string) => {
                        return Object.assign(device, {
                            [key]: data[index][key],
                        });
                    }, {})
            );
        }
        return newData;
    };

    public static OpenContentInNewTab = (content: any, contentType: string) => {
        const blob = new Blob([content], { type: contentType });
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };

    public static downloadFile = (
        fileContent: any,
        fileType: string,
        fileName: string
    ) => {
        const link = document.createElement('a');
        link.download = fileName;
        link.target = '_blank';
        const blob = new Blob([fileContent], { type: fileType });
        const url = URL.createObjectURL(blob);
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    public static getFilterValue = (
        field: string,
        filteredColumns?: FilteredColumn[]
    ) => {
        if (!filteredColumns?.length) {
            return undefined;
        }
        return (
            filteredColumns
                .find((x) => x.criteria.some((e) => e.fieldName === field))
                ?.criteria?.find((x) => x.fieldName === field)
                ?.filterValue?.toString() ?? undefined
        );
    };

    public static AdjustDateTime = (
        date: Date | undefined,
        hours: number | undefined = undefined,
        minutes: number | undefined = undefined,
        seconds: number | undefined = undefined
    ): Date | undefined => {
        if (!date) return undefined;
        const now: Date = new Date();
        const dateTime: Date = date;
        dateTime.setHours(hours || now.getHours());
        dateTime.setMinutes(minutes || now.getMinutes());
        dateTime.setSeconds(seconds || now.getSeconds());
        return dateTime;
    };

    public static showSchema = (schema: string, schemaType: string) => {
        const blob = new Blob([schema], { type: schemaType });
        const url = URL.createObjectURL(blob);
        window.open(url);
        URL.revokeObjectURL(url);
    };

    public static dateInPast = (value: Date | undefined) => {
        return !!(
            value &&
            value.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
        );
    };

    public static FormatDatePickerValue = (
        date: Date | undefined,
        currentLocale?: string
    ): string => {
        const locale =
            currentLocale && currentLocale !== '' ? currentLocale : 'en-gb'; // default

        if (locale?.trim().toLocaleLowerCase().startsWith('en')) {
            return date
                ? `${date.getDate().toLocaleString(locale)}/${(
                    date.getMonth() + 1
                ).toLocaleString(locale)}/${date
                    .getFullYear()
                    .toLocaleString(locale)
                    .replace(/,/g, '')}`
                : '';
        }
        return date
            ? `${date
                .getFullYear()
                .toLocaleString(locale)
                .replace(/٬/g, '')}/${(date.getMonth() + 1).toLocaleString(
                    locale
                )}/${date.getDate().toLocaleString(locale)}`
            : '';
    };

    public static getLocalizedDateTime = (
        type: string,
        date: Date | undefined,
        locale?: string,
        toUTC = false,
        hours12 = true
    ) => {
        if (!date) return '';
        const newDate = new Date(`${date}${toUTC ? 'Z' : ''}`);
        const dateOptions = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        };
        const timeOtions = {
            hour: 'numeric',
            minute: 'numeric',
            hour12: hours12,
        };
        let localDate = '';
        switch (type) {
            case 'Date':
                localDate = newDate?.toLocaleDateString(
                    locale?.startsWith('ar') ? 'ar-EG' : ['ban', 'id'],
                    dateOptions
                );
                break;
            case 'DateTime':
                localDate = `${UIHelpers.getLocalizedDateTime(
                    'Date',
                    date,
                    locale,
                    toUTC,
                    hours12
                )} ${UIHelpers.getLocalizedDateTime(
                    'Time',
                    date,
                    locale,
                    toUTC,
                    hours12
                )}`;
                break;
            case 'Time':
                localDate = newDate?.toLocaleTimeString(
                    locale?.startsWith('ar') ? 'ar-EG' : 'en-US',
                    timeOtions
                );
                break;
            default:
                localDate = newDate?.toLocaleString();
        }
        return localDate;
    };

    public static AdjustDate = (date?: Date): Date | undefined => {
        if (!date) return undefined;
        const now: Date = new Date();
        const dateTime: Date = new Date(date ?? now);

        dateTime.setHours(23);
        dateTime.setMinutes(59);
        dateTime.setSeconds(59);
        return dateTime;
    };

    public static ParseDatePickerString = (val: string): Date | null => {
        const values = (val || '').trim().split('/');
        const day =
            val.length > 0
                ? Math.max(1, Math.min(31, parseInt(values[0], 10)))
                : null;
        const month =
            val.length > 1
                ? Math.max(1, Math.min(12, parseInt(values[1], 10))) - 1
                : null;
        const year = val.length > 2 ? parseInt(values[2], 10) : null;

        return day && month && year ? new Date(year, month, day) : null;
    };

    public static getFormattedDate = (date: Date | undefined) => {
        if (!date) return '';
        const localDate = date.toLocaleString();
        return Moment(localDate).format(Dates.Date);
    };

    public static isArLang = (currentLanguage: Language) =>
        currentLanguage.langIso4.trim().toLowerCase().startsWith('ar');

    public static getLocalizedName(
        nameEn: string | undefined,
        nameAr: string | undefined,
        currentLang: Language
    ) {
        let name;
        if (UIHelpers.isArLang(currentLang)) {
            name = isEmptyText(nameAr ?? '') ? nameEn : nameAr;
        } else {
            name = isEmptyText(nameEn ?? '') ? nameAr : nameEn;
        }
        return name;
    }


    public static getUTCStartDate = (localDate?: Date | undefined) => {
        if (!localDate) return undefined;
        const utcDate = new Date(
            Date.UTC(
                localDate.getFullYear(),
                localDate.getMonth(),
                localDate.getDate()
            )
        );
        utcDate.setHours(0);
        utcDate.setMinutes(0);
        utcDate.setSeconds(0);
        return utcDate;
    };

    public static getUTCEndDate = (localDate?: Date | undefined) => {
        if (!localDate) return null;
        const utcDate = new Date(
            Date.UTC(
                localDate.getFullYear(),
                localDate.getMonth(),
                localDate.getDate()
            )
        );
        utcDate.setHours(23);
        utcDate.setMinutes(59);
        utcDate.setSeconds(59);
        return utcDate;
    };
}

export const EnsureNotSlashAtEnd = (url: string): string => {
    const lastIndex = url?.lastIndexOf('/');
    if (lastIndex !== 1) {
        return url?.slice(0, lastIndex);
    }
    return url;
};

export const ReportIssue = (devId?: number) => {
    const invoicingPortalURL = (window as any)
        .REACT_APP_InvoicingPortalURL as string;
    window.location.href = `${EnsureNotSlashAtEnd(
        invoicingPortalURL
    )}/issues?pos=${devId}`;
};

export const getLocalizedName = (nameEn: string, nameAr: string, currentLanguage?: Language) => {
    let name;
    if (currentLanguage?.langIso4.toLowerCase().startsWith('en')) {
        name = isEmptyText(nameEn ?? '') ? nameAr : nameEn;
    } else {
        name = isEmptyText(nameAr ?? '') ? nameEn : nameAr;
    }
    return name;
};

export const SuccessMessageDuration = 10000;

export const NumberOfShimmerLines = 5;
